module.exports = __webpack_public_path__ + "static/5-4b77e2d448f2d8afaafe197fb8d1074c.png";